module.exports = __webpack_public_path__ + "img/Dazzle.bcc80b70.png";